import React from "react";
import { Button, FormGroup, Radio, Alert } from "react-bootstrap";
import FontAwesome from "react-fontawesome";
import classNames from "classnames";
import moment from "moment";

import PeriodInput, { getPeriodString } from "./PeriodInput";
import DateInput from "./DateInput";
import RevisionsPopup from "./RevisionsPopup";

const TYPE_PERIOD = "period";
const TYPE_FIXED_DATE = "fixed-date";

export default class DurationInput extends React.Component {
  constructor(props) {
    super(props);
    let type = props.product.duration ? TYPE_PERIOD : TYPE_FIXED_DATE;
    this.state = {
      readonly: true,
      type,
      product: {
        ...props.product,
      },
    };
  }

  onSave() {
    let product = {
      ...this.props.product,
    };
    if (this.state.type === TYPE_PERIOD) {
      product.fixedStartDate = null;
      product.fixedEndDate = null;
    } else {
      product.duration = null;
    }
    this.setState({
      readonly: true,
    });
    this.props.onSave(product);
  }

  onChangePeriod(value) {
    let product = this.state.product;
    product.duration = value;
    this.setState({
      product,
      type: TYPE_PERIOD,
    });
  }

  onChangeDate(property, value) {
    this.setState({
      product: {
        ...this.state.product,
        [property]: value,
      },
    });
  }

  changeType(type) {
    this.setState({
      type,
    });
  }

  getReadonlyValue() {
    const { product } = this.state;
    if (this.state.type === TYPE_PERIOD) {
      return getPeriodString(product.duration);
    } else {
      let startDate, endDate;
      if (product.fixedStartDate) {
        startDate = moment(product.fixedStartDate, "YYYY-MM-DD").format(
          "DD-MM-YYYY"
        );
      }
      if (product.fixedEndDate) {
        endDate = moment(product.fixedEndDate, "YYYY-MM-DD").format(
          "DD-MM-YYYY"
        );
      }
      return `${startDate ? startDate : "-"} / ${endDate ? endDate : "-"}`;
    }
  }

  getValueElement() {
    const { product, type } = this.state;
    if (this.state.readonly) {
      return this.getReadonlyValue();
    } else {
      return (
        <FormGroup>
          <Radio
            checked={type === TYPE_FIXED_DATE}
            onChange={(e) => this.changeType(e.target.value)}
            name="radioGroup"
            value={TYPE_FIXED_DATE}
            className={TYPE_FIXED_DATE}
          >
            <div className="date">
              <label> Startdatum </label>
              <DateInput
                value={product.fixedStartDate}
                onChange={(value) => this.onChangeDate("fixedStartDate", value)}
                disabled={type !== TYPE_FIXED_DATE}
              />
            </div>
            <div className="date">
              <label> Einddatum </label>
              <DateInput
                value={product.fixedEndDate}
                onChange={(value) => this.onChangeDate("fixedEndDate", value)}
                disabled={type !== TYPE_FIXED_DATE}
              />
            </div>
          </Radio>
          {product.fixedEndDate &&
            product.fixedStartDate &&
            product.fixedEndDate < product.fixedStartDate && (
              <Alert bsStyle="danger">
                Einddatum mag niet voor de startdatum liggen
              </Alert>
            )}
          <Radio
            checked={type === TYPE_PERIOD}
            onChange={(e) => this.changeType(e.target.value)}
            name="radioGroup"
            value={TYPE_PERIOD}
            className={TYPE_PERIOD}
          >
            <PeriodInput
              value={product.duration}
              onChange={(value) => this.onChangePeriod(value)}
              disabled={type !== TYPE_PERIOD}
            />
          </Radio>
        </FormGroup>
      );
    }
  }

  getButtonsElement() {
    if (this.state.readonly) {
      return (
        <div className="buttons">
          {" "}
          {this.props.entity ? (
            <RevisionsPopup
              {...this.props}
              type="duration"
              property="duration,fixedStartDate,fixedEndDate"
            />
          ) : (
            <span />
          )}{" "}
          <FontAwesome
            id="edit-duration"
            name="pencil"
            size="lg"
            onClick={() =>
              this.setState({
                readonly: false,
              })
            }
          />{" "}
        </div>
      );
    } else {
      return (
        <div className="buttons">
          <Button
            disabled={this.saveDisabled()}
            className="save-property"
            onClick={() => this.onSave()}
          >
            Opslaan{" "}
          </Button>{" "}
        </div>
      );
    }
  }

  saveDisabled() {
    const { product, type } = this.state;
    if (type === TYPE_FIXED_DATE) {
      if (!product.fixedEndDate) {
        return false;
      }
      if (!product.fixedStartDate) {
        return true;
      }
      return product.fixedEndDate < product.fixedStartDate;
    }
    return false;
  }

  render() {
    let valueElement = this.getValueElement();
    let buttonsElement = this.getButtonsElement();
    return (
      <div
        className={classNames(
          "property-input",
          {
            [`${this.props.className}`]: this.props.className !== undefined,
          },
          "type-duration-input",
          {
            "edit-mode": !this.state.readonly,
          }
        )}
      >
        <div className="input-header">
          <FontAwesome name="calendar-plus-o" size="lg" /> Duur {buttonsElement}{" "}
        </div>{" "}
        <span className="value"> {valueElement} </span>{" "}
      </div>
    );
  }
}
